import { Link } from "react-router-dom";
import ReactDOM from "react-dom";
import React, { useState } from "react";
import ModalWrapper from "../../../Component/ModalWrapper";
import { AddObjectModalContents } from "./AddObjectModalContents";

type NewObjectButtonProps = {
    createObject: Function;
    openTitle?: string;
    look: string;
    show: boolean;
};

function NewObjectButtonContainer({
    createObject,
    look,
    openTitle =  "+ New Card",
    show,
}: NewObjectButtonProps) {
    const [isOpen, setModalOpen] = useState(false);


    if (show) {
        return (
            <ModalWrapper
                setModalOpen={setModalOpen}
                modalIsOpen={isOpen}
                look={look}
                openTitle={openTitle}
            >
                <AddObjectModalContents
                    createObject={createObject}
                    setModalOpen={setModalOpen}
                />
            </ModalWrapper>
        );
    }
    return <span></span>;
}

export { NewObjectButtonContainer };
